import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { joinClassNames } from '../../utils';

Obfuscated.propTypes = {
    className: PropTypes.string,
};

Obfuscated.defaultProps = {
    className: null,
};

function Obfuscated(props) {
    const {
        className,
    } = props;
    const { t } = useTranslation();
    return (
        <span className={joinClassNames('bid-row--obfuscated', className)}>{t('auctions.bids-list.bid-row.obfuscated')}</span>
    );
}

export default Obfuscated;
